import { useEffect, useMemo } from "react";
import analytics from "../../analytics/analytics.js";
import { mapManager } from "./googleMapManager.js";
const handleCatctError = (error)=>{
    analytics.logError({
        loggedFrom: 'useGoogleMapsHooks',
        message: 'Failed to initialize google maps',
        error: error?.message
    });
};
const useGoogleMapsHooks = ({ hotelPinsOnMap, locationPinsOnMap, setiValues })=>{
    const hotelPinKeys = useMemo(()=>Object.keys(hotelPinsOnMap), [
        hotelPinsOnMap
    ]);
    const locationPinKeys = useMemo(()=>Object.keys(locationPinsOnMap), [
        locationPinsOnMap
    ]);
    const hotelKeysSignature = hotelPinKeys.join('|');
    const locationKeysSignature = locationPinKeys.join('|');
    useEffect(()=>{
        const hasPins = 0 !== hotelPinKeys.length || 0 !== locationPinKeys.length;
        if (!hasPins) return void mapManager.clearMarkers();
        mapManager.initloader({
            setiValues
        });
        mapManager.setMap().then(()=>{
            const mergedPinsMap = {
                ...locationPinsOnMap,
                ...hotelPinsOnMap
            };
            mapManager.syncMarkers(mergedPinsMap);
            return mapManager.fitBoundsOnCurrentMap(Object.keys(mergedPinsMap).map((key)=>mergedPinsMap[key])).catch((error)=>{
                analytics.logError({
                    loggedFrom: 'useGoogleMapsHooks',
                    message: 'Failed to call fitBoundsOnCurrentMap on mapManager',
                    error: error.message
                });
            }).finally(()=>{
                mapManager.fireCallbacks();
            });
        }).catch(handleCatctError);
    }, [
        hotelKeysSignature,
        locationKeysSignature,
        setiValues
    ]);
};
export { handleCatctError, useGoogleMapsHooks };
